import React, { useState } from 'react';
import { View, Dimensions, StyleSheet } from 'react-native';
import { useTheme } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../components/CustomButton/CustomButton';
import TopTabNavigation from '../../navigation/TopTabNavigation';

const width = Dimensions.get('window').width;

const HomeShortcutPages = () => {
    const { t } = useTranslation();

    const DATA = [0, 1];
    const { colors } = useTheme()
    const styles = makeStyles(colors)

    {/* Remove PageControl for Tab Navivgation  */ }
    const [pageNum, setPageNum] = useState(0);
    const [title, setTitle] = useState(t('navigate:LM'))

    const renderData = (item) => {
        return (
            <View style={[styles.renderPage]}>
                {item.item === 0 &&
                    <CustomButton
                        // onPress={() => selectPageOne()}
                        iconName='log-out-outline'
                        show='HOME_SELECTED'
                        type='HOME_SELECTED'
                        textTop='2'
                        sz={30} />
                }
                {item.item === 1 &&
                    <CustomButton
                        iconName='trending-up-outline'
                        // onPress={() => selectPageTwo()}
                        show='HOME_SELECTED'
                        type='HOME_SELECTED'
                        textTop='2'
                        sz={30} />
                }
                <View style={styles.line} />
            </View>
        )
    };

    const selectPageOne = () => {
        setPageNum(0)
        setTitle(t('navigate:LM'))
    }

    const selectPageTwo = () => {
        setPageNum(1)
        setTitle(t('navigate:AM'))
    }

    const onScroll = (e) => {
        // Get progress by dividing current FlatList X offset with full FlatList width
        let prog = e.nativeEvent.contentOffset.x / ((DATA.length - 1) * width)
        if (prog == 0)
            selectPageOne()
        else if (prog > 0.48 && prog <= 0.87) {
            selectPageTwo()
        }

    };

    return (

        <TopTabNavigation drawer='Home' />
    )
}

const makeStyles = (colors) => StyleSheet.create({
    main: {
        flex: 1,
    },
    renderPage: {
        marginRight: 0,
        flex: 1,
        width: width,
        borderColor: colors.background,
        borderWidth: 0
    },
    line: {
        borderBottomColor: colors.card_line,
        borderBottomWidth: StyleSheet.hairlineWidth,
        marginTop: "5%",
        marginBottom: "0%",
    },
})
export default HomeShortcutPages;